import { render } from "./level-update-card.vue?vue&type=template&id=5f6fbbfc&scoped=true&ts=true"
import script from "./level-update-card.vue?vue&type=script&lang=ts"
export * from "./level-update-card.vue?vue&type=script&lang=ts"

import "./level-update-card.vue?vue&type=style&index=0&id=5f6fbbfc&lang=scss&scoped=true"
import "./level-update-card.vue?vue&type=style&index=1&id=5f6fbbfc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6fbbfc"]])

export default __exports__